export default __webpack_public_path__ + "static/media/c3Logo.0d8a1cbd.png";